import $ from 'jquery';

export const scroll = () => {

    const el = $('.js-scroll');

    el.on('click', function (event) {
        event.preventDefault();

        const target = $(this).attr('href');
    
        $('html, body').animate({ scrollTop: $(target).offset().top }, 500);
    });
}